import { render, staticRenderFns } from "./centro-custo.vue?vue&type=template&id=bf0de2b4&"
import script from "./centro-custo.vue?vue&type=script&lang=js&"
export * from "./centro-custo.vue?vue&type=script&lang=js&"
import style0 from "./centro-custo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports